import Vue from 'vue';
import VueRouter from 'vue-router'
import App from './App.vue'
import AnketGoster from './AnketGoster.vue'
import Hata from './Hata.vue'
import VueElementLoading from "vue-element-loading";

Vue.use(VueRouter)
Vue.component("VueElementLoading", VueElementLoading);
Vue.config.productionTip = false
const Foo = { template: '<div>TOBB YAZILIM MÜDÜRLÜĞÜ @2020</div>' }
const routes = [
  { path: '/', component: Foo },
  { name:'hata', path: '/hata', component: Hata, props: true },
  { path: '/anket/:kisaurl', component: AnketGoster },
  { path: '/anket/:kisaurl/:kisiid', component: AnketGoster }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes // short for `routes: routes`
})
new Vue({
  render: h => h(App),
  router,
  components: { App, Foo, AnketGoster, VueElementLoading}
}).$mount('#app')
